module.exports = __webpack_public_path__ + "img/qs-l3_0.prt.d13756bc.jpg";